import React, { useEffect } from "react";

const RedirectToExternal = ({uri}) => {
    useEffect(() => {
        window.location.replace(uri);
    }, []);

    return(
        <div className="absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center bg-white z-50">
            <div>
                <p className="text-slate-600 text-level-2">Redirecting...</p>
            </div>
        </div>
    );
};

export default RedirectToExternal;